<app-simple-modal [title]="'Crear Partida'" (close)="close.emit($event)">
	<div fields>
		<div class="row">
			<div class="col-sm-4">
				<div class="row">
					<div class="col form-group">
						<label for="initial" class="form-label">Tipo de Partida</label>
						<div class="input-group">
							<button [ngClass]="newJournal.initial?'btn-success':'btn-secondary'" class="btn"
								(click)="newJournal.initial = !newJournal.initial"><i
									[ngClass]="newJournal.initial?'fa-toggle-on':'fa-toggle-off'"
									class="fa"></i></button>
							<input type="text" disabled [placeholder]="newJournal.initial?'Inicial':'No Inicial'"
								class="form-control">
						</div>
					</div>
					<div class="col form-group">
						<label for="date" class="form-label">Fecha <span class="text-danger"><i
									class="fa fa-asterisk"></i></span></label>
						<input type="date" id="date" [(ngModel)]="newJournal.date" name="date" class="form-control">
					</div>
				</div>
			</div>
			<div class="col-sm-8 form-group">
				<label for="description" class="form-label">Descripción <span class="text-danger"><i
							class="fa fa-asterisk"></i></span></label>
				<input type="text" name="description" [(ngModel)]="newJournal.description" class="form-control"
					id="description" placeholder="Ingresa la descripción">
			</div>
		</div>
		<div class="input-group mt-3">
			<label for="account" class="input-group-text">Cuenta <span class="text-danger"><i
						class="fa fa-asterisk"></i></span></label>
			<app-input-autocomplete [typeElements]="'account'"
				(getTitle)="$event.filterElement.title = $event.filterElement.displayId + ' '+ $event.filterElement.name"
				[filterElements]="inputAccount.filter" [inputs]="inputAccount" (inputMethod)="writeAccount()"
				(changeStatus)="selectAccount($event.filterElement)"></app-input-autocomplete>
			<label for="debit" class="input-group-text">Debito</label>
			<input type="number" placeholder="0.00" [(ngModel)]="tempEntry.debit" name="debit" id="debit"
				class="form-control">
			<label for="credit" class="input-group-text">Crédito</label>
			<input type="number" placeholder="0.00" [(ngModel)]="tempEntry.credit" name="credit" id="credit"
				class="form-control">
			<button class="btn btn-success" (click)="addAccount()"><i class="fa fa-circle-plus"></i></button>
		</div>
		<div class="table-responsive mt-1" *ngIf="newJournal.entries.length > 0">
			<table class="table table-bordered">
				<thead>
					<tr class="tr-middle">
						<th>Cuenta Contable</th>
						<th>Nombre</th>
						<th>Debe</th>
						<th>Haber</th>
						<th *ngIf="differences.length > 0">Diferencias</th>
					</tr>
				</thead>
				<tbody>
					<tr class="tr-middle" *ngFor="let entry of newJournal.entries; let i = index">
						<td class="edit" (click)="editEntry(entry,i)">{{accountData[entry.account].displayId}} <i
								class="fa fa-edit"></i></td>
						<td>{{accountData[entry.account].name}}</td>
						<td>{{entry.debit | currency: 'Q'}}</td>
						<td>{{entry.credit | currency: 'Q'}}</td>
						<td class="limit-td-100" *ngIf="differences.length > 0">
							<span
								*ngIf="differenceData[accountData[entry.account].displayId]">{{differenceData[accountData[entry.account].displayId]}}</span>
							<span *ngIf="!differenceData[accountData[entry.account].displayId]" class="text-muted"><i
									class="fa fa-circle-info"></i>Sin diferencias.</span>
						</td>
					</tr>
					<tr class="tr-middle">
						<td colspan="2">
							<b *ngIf="newJournal.description">{{newJournal.description}}</b>
							<span *ngIf="!newJournal.description" class="text-muted"><i
									class="fa fa-circle-info"></i>Falta que ingreses una descripción</span>
						</td>
						<td [ngClass]="!balancedAccounts() ?'bg-danger':'bg-success'">{{totalDebit | currency: 'Q'}}
						</td>
						<td [ngClass]="!balancedAccounts() ?'bg-danger':'bg-success'">{{totalCredit | currency:
							'Q'}}
						</td>
						<td class="limit-td-100" *ngIf="differences.length > 0"><i
								class="fa fa-warning"></i>{{differenceData['total']}}</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
	<div buttons>
		<app-loading-button *ngIf="newJournal.initial" [object]="buttonCheck" [disabled]="!balancedAccounts() || !newJournal.date ||
		!newJournal.description || newJournal.entries.length == 0" (clicked)="checkEntry()"></app-loading-button>
		<app-loading-button [object]="buttonSave" [disabled]="!balancedAccounts() || !newJournal.date ||
		!newJournal.description || newJournal.entries.length == 0" (clicked)="saveEntry()"></app-loading-button>
	</div>
</app-simple-modal>